import { useLocation, useNavigate } from "react-router-dom";
import { TextSS, TextRXS, TextM, TextS } from "../../common/text";
import {
  Ticket,
  TicketTextWrapper,
  TicketImg,
  TicketListWrapper,
  ButtonWrapper,
  Button,
  BankSelect,
  BankWrapper,
  AccountHolder,
  BankBoxWrapper,
  BankText,
  BankOption,
  AccountInput,
  ContentContainer,
  AccountHolderWrapper,
  RefundInfoWrapper,
  TextBox,
  DataSet,
} from "./TicketCancel.styles";
import { CFormCheck } from "@coreui/react";
import DetailPageLayout from "../Layout/DetailPageLayout";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  useBanks,
  useGetRecentAccount,
  toFirstElement,
  useCancelTicket,
  findBank,
} from "./TicketCancel.helpers";
import { useRecoilValue } from "recoil";
import { authAtom } from "../../recoil/atoms";
import TicketRefundInfo from "./TicketRefundInfo";
import moment, { now } from "moment";

const TicketCancel = () => {
  const {
    state: { ticket },
  } = useLocation();

  const { data: fetchedBanks, isSuccess: isFetchedBanksSuccess } = useBanks();
  const { data: recentAccount, isSuccess: isRecentAccountSuccess } =
    useGetRecentAccount(ticket.purchasePk);

  const { name } = useRecoilValue(authAtom);
  const { mutate: cancelTicket } = useCancelTicket();

  const [accountNum, setAccountNum] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const onChecked = ({ target }) => {
    target.checked ? setIsChecked(true) : setIsChecked(false);
  };

  // 환불규정#2 : 취소화면에서 마감날짜로 넘어가면 작성중에도 취소 불가처리 / 이전 페이지로 이동
  const deadline = moment(ticket.sendDate).add(7, "d").format("YYYY-MM-DD");
  const navigate = useNavigate();
  const goToMyTicket = (pk) => {
    navigate("/my-tickets/" + pk, { state: { ticket }, replace: true });
  };

  const onAccountHolderChange = (e) => {
    setAccountHolder(e.target.value);
  };
  const onAccountNumChange = (e) => {
    setAccountNum(e.target.value);
  };
  const onBankSelectChange = (e) => {
    setSelectedBank(e.target.value);
  };

  const onClickCancelTicket = () => {
    const bankData = findBank(banks, selectedBank);
    if (bankData === null) return;
    if (!isChecked) {
      alert("환불규정에 동의해주세요");
      return;
    }
    if (!accountNum) {
      alert("계좌번호를 입력해주세요");
      return;
    }
    if (moment(deadline).isAfter(moment().format("YYYY-MM-DD")) === false) {
      alert(
        "환불가능기한이 만료되어 취소할 수 없습니다.\n\n환불가능기한 : " +
          deadline +
          " 00:00:00"
      );
      goToMyTicket();
      return;
    }

    cancelTicket({
      purchasePk: ticket.purchasePk,
      stockPk: ticket.pk,
      bank: selectedBank,
      bankCode: bankData.code,
      account: accountNum,
      accountHolder,
      isAgree: isChecked,
    });
  };

  useEffect(() => {
    if (isRecentAccountSuccess) {
      setAccountNum(recentAccount.account);
      setAccountHolder(recentAccount.accountHolder);
      if (isFetchedBanksSuccess) {
        toFirstElement(fetchedBanks, recentAccount.bank);
        setBanks(fetchedBanks);
        setSelectedBank(fetchedBanks[0]?.name);
      }
    }
  }, [isRecentAccountSuccess, isFetchedBanksSuccess]);

  return (
    <DetailPageLayout headerText={ticket.product?.name}>
      <Helmet>
        <title>구매취소</title>
      </Helmet>
      <ContentContainer>
        <TicketListWrapper>
          <Ticket>
            <TicketImg src={ticket.product?.images[0]} alt="티켓" />
            <TextBox>
              <DataSet>
                <TextSS>옵션</TextSS>
                <TextRXS>{ticket?.product?.div}</TextRXS>
              </DataSet>
              <DataSet>
                <TextSS>이용기간</TextSS>
                <TextRXS>{ticket.validDate}</TextRXS>
              </DataSet>
            </TextBox>
          </Ticket>
        </TicketListWrapper>
        <BankBoxWrapper>
          <BankText>[입금 은행]</BankText>
          <BankWrapper>
            <BankSelect value={selectedBank} onChange={onBankSelectChange}>
              {banks.map(({ pk, name }) => (
                <BankOption key={pk}>{name || ""}</BankOption>
              ))}
            </BankSelect>
            <AccountInput
              onChange={onAccountNumChange}
              value={accountNum || ""}
              placeholder="입금 계좌번호"
            ></AccountInput>
          </BankWrapper>
          <AccountHolderWrapper>
            <TextS>예금주</TextS>
            <AccountHolder>{name}</AccountHolder>
          </AccountHolderWrapper>
        </BankBoxWrapper>
        <RefundInfoWrapper>
          <TicketRefundInfo ticket={ticket} />
        </RefundInfoWrapper>

        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          <CFormCheck onClick={onChecked} id="defaultCheck1" />
          <TextSS>동의합니다.</TextSS>
        </div>

        <ButtonWrapper>
          <Button onClick={onClickCancelTicket} isChecked={isChecked}>
            <TextM color={isChecked ? "#FFF" : "#9F9F9F"}>취소신청</TextM>
          </Button>
        </ButtonWrapper>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default TicketCancel;
